import React from "react";
import T from "prop-types";

import Widget from "2g-widget";
import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, Inputs, Row, ActionButton } from "2g-form";
import { required } from "2g-validators-common";

import DoplnkovaSluzbaEditaceWidgetTitleDescription from "./DoplnkovaSluzbaEditaceWidgetTitleDescription";
import useDoplnkovaSluzbaEditaceWidget from "./useDoplnkovaSluzbaEditaceWidget";
import useMessages from "./i18n/useMessages";

const requiredValidator = required();

export function DoplnkovaSluzbaWidget({ doplnkovaSluzba, loading }) {
  const { buttonDelete, buttonSubmit, buttonCancel } = useMessages();
  const { formModuleKey, onSubmit, onCancel, onDelete } =
    useDoplnkovaSluzbaEditaceWidget({
      doplnkovaSluzba
    });
  return (
    <Widget
      collapsable={false}
      title={
        <DoplnkovaSluzbaEditaceWidgetTitleDescription
          doplnkovaSluzba={doplnkovaSluzba}
          loading={loading}
        />
      }
    >
      <Form moduleKey={formModuleKey} onSubmit={onSubmit} disabled={loading}>
        <Row styled>
          <Field
            component={Inputs.Input}
            path="nazevCs"
            label="b2b.doplnkova-sluzba-editace-form.field.nazevCs.label"
            validators={requiredValidator}
            required
          />
          <Field
            component={Inputs.Input}
            path="nazevEn"
            label="b2b.doplnkova-sluzba-editace-form.field.nazevEn.label"
            validators={requiredValidator}
            required
          />
        </Row>
        <Row styled>
          <Field
            component={Inputs.TextArea}
            path="popisCs"
            label="b2b.doplnkova-sluzba-editace-form.field.popisCs.label"
          />
          <Field
            component={Inputs.TextArea}
            path="popisEn"
            label="b2b.doplnkova-sluzba-editace-form.field.popisEn.label"
          />
        </Row>
        <Row styled>
          <Field
            component={Inputs.Input}
            path="zkratka"
            label="b2b.doplnkova-sluzba-editace-form.field.zkratka.label"
            validators={requiredValidator}
            required
          />
          <div className="b2b-Form-checboxGroup">
            <Field
              component={Inputs.Checkbox}
              path="uzivaNapajeni"
              label="b2b.doplnkova-sluzba-editace-form.field.uzivaNapajeni.label"
              light
            />
            <Field
              component={Inputs.Checkbox}
              path="vylucny"
              label="b2b.doplnkova-sluzba-editace-form.field.vylucny.label"
              light
            />
          </div>
        </Row>
        <ButtonsSet>
          {doplnkovaSluzba ? (
            <ActionButton button={Buttons.Danger} onClick={onDelete} inverse>
              {buttonDelete()}
            </ActionButton>
          ) : undefined}
          <ActionButton button={Buttons.Primary} validate submit inverse>
            {buttonSubmit()}
          </ActionButton>
          <ActionButton button={Buttons.Default} onClick={onCancel}>
            {buttonCancel()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

DoplnkovaSluzbaWidget.propTypes = {
  doplnkovaSluzba: T.object,
  loading: T.bool
};

export default React.memo(DoplnkovaSluzbaWidget);
